import React from "react";

const Modal = ({
  title,
  onClose,
  onSubmit,
  submitButtonText,
  showCancel,
  showSubmitButton,
  children,
  className = "",
  submitButtonClass = "bg-indigo-600 hover:bg-indigo-700 text-white",
  disableSubmit = false,
  error = "",
}) => {
  const canClose = typeof onClose === "function" && !disableSubmit;

  return (
    <div className="fixed left-0 top-0 z-[9999] h-dvh w-screen overflow-y-auto bg-black/40 backdrop-blur-sm">
      <div className="min-h-full px-4 py-4 sm:px-6">
        <div className="flex min-h-[calc(100dvh-2rem)] items-center justify-center">
          <div
            className={`relative max-h-[95dvh] w-full max-w-lg rounded-2xl bg-white p-6 shadow-2xl animate-in fade-in zoom-in-95 duration-200 ${className}`}
          >
            {/* 🔵 Loading Overlay */}
            {disableSubmit && (
              <div className="absolute inset-0 z-20 flex items-center justify-center rounded-2xl bg-white/70 backdrop-blur-sm">
                <div className="h-10 w-10 animate-spin rounded-full border-4 border-slate-200 border-t-slate-900"></div>
              </div>
            )}

            <button
              type="button"
              onClick={canClose ? onClose : undefined}
              disabled={!canClose}
              className={`absolute right-4 top-4 transition p-2 rounded-full hover:bg-slate-100 ${
                canClose
                  ? "text-slate-400 hover:text-slate-700"
                  : "cursor-not-allowed text-slate-300"
              }`}
            >
              <i className="fas fa-times text-lg"></i>
            </button>

            {title && (
              <h2 className="mb-4 text-xl font-bold text-slate-900 tracking-tight">
                {title}
              </h2>
            )}

            {error && (
              <div className="mb-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-600 font-medium flex items-center gap-2">
                <i className="fas fa-exclamation-circle"></i>
                {error}
              </div>
            )}

            <form onSubmit={onSubmit} className="space-y-4">
              {children}

              {(showCancel || showSubmitButton) && (
                <div className="flex justify-end gap-2 pt-2">
                  {showCancel && (
                    <button
                      type="button"
                      onClick={canClose ? onClose : undefined}
                      disabled={!canClose}
                      className={`rounded-lg px-4 py-2 transition ${
                        canClose
                          ? "bg-slate-200 text-slate-700 hover:bg-slate-300"
                          : "cursor-not-allowed bg-slate-100 text-slate-400"
                      }`}
                    >
                      Cancel
                    </button>
                  )}

                  {showSubmitButton && (
                    <button
                      type="submit"
                      disabled={disableSubmit}
                      className={`inline-flex items-center gap-2 rounded-lg px-4 py-2 transition ${
                        disableSubmit
                          ? "cursor-not-allowed bg-slate-300 text-white"
                          : submitButtonClass
                      }`}
                    >
                      {disableSubmit && (
                        <span className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></span>
                      )}
                      {submitButtonText}
                    </button>
                  )}
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;